// Shared date/time formatting helpers — StrangerSessions.net displays all dates as
// M-D-YYYY and all times in am/pm format, everywhere in the app.

export function formatDate(dateStr) {
  if (!dateStr) return "";
  const datePart = dateStr.length > 10 ? dateStr.slice(0, 10) : dateStr;
  const parts = datePart.split("-").map(Number);
  if (parts.length !== 3 || parts.some((n) => Number.isNaN(n))) return dateStr;
  const [y, m, d] = parts;
  return `${m}-${d}-${y}`;
}

export function formatTime(timeStr) {
  if (!timeStr) return "";
  const [hStr, mStr] = timeStr.slice(0, 5).split(":");
  let h = parseInt(hStr, 10);
  if (Number.isNaN(h)) return timeStr;
  const m = (mStr || "00").padStart(2, "0");
  const period = h >= 12 ? "PM" : "AM";
  h = h % 12;
  if (h === 0) h = 12;
  return `${h}:${m} ${period}`;
}

/** For full ISO timestamps like created_at ("2026-08-13T19:21:14.000Z"). */
export function formatDateTime(isoStr) {
  if (!isoStr) return "";
  const datePart = isoStr.slice(0, 10);
  const timePart = isoStr.slice(11, 16);
  const date = formatDate(datePart);
  const time = timePart ? formatTime(timePart) : "";
  return time ? `${date} ${time}` : date;
}

/** Combined "session_date at session_time" helper used throughout session/booking cards. */
export function formatSessionDateTime(dateStr, timeStr) {
  const date = formatDate(dateStr);
  const time = formatTime(timeStr);
  return time ? `${date} at ${time}` : date;
}
